import { apiClient } from './apiClient';

export interface CreateMagicLinkRequest {
  email: string;
  userId?: string;
  targetPath: string;
  targetParams?: Record<string, any>;
  ttlMinutes?: number;
  oneTimeUse?: boolean;
}

export interface CreateMagicLinkResponse {
  success: boolean;
  data: {
    magicLinkUrl: string;
    expiresAt: string;
  };
}

export interface ConsumeMagicLinkResponse {
  success: boolean;
  data: {
    targetPath: string;
    targetParams?: Record<string, any>;
    requiresAuth: boolean;
  };
  message?: string;
  code?: 'EXPIRED' | 'ALREADY_USED' | 'INVALID_USER' | 'INVALID_TOKEN';
}

/**
 * Create a magic link token
 */
export const createMagicLink = async (
  request: CreateMagicLinkRequest,
  token: string
): Promise<CreateMagicLinkResponse> => {
  const response = await apiClient('magic-links', {
    method: 'POST',
    token,
    body: request,
  });

  return response.json();
};

/**
 * Consume a magic link token (public endpoint, no auth required)
 */
export const consumeMagicLink = async (
  token: string,
  email?: string
): Promise<ConsumeMagicLinkResponse> => {
  const queryParams: Record<string, string> = { t: token };
  if (email) {
    queryParams.email = email;
  }

  const response = await fetch(`${import.meta.env.VITE_API_URL}magic?${new URLSearchParams(queryParams).toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw {
      message: data.message || 'Failed to consume magic link',
      code: data.code || 'INVALID_TOKEN',
      statusCode: response.status,
    };
  }

  return data;
};

